import { render } from "./LibraryDocument.vue?vue&type=template&id=33149ba8&scoped=true&ts=true"
import script from "./LibraryDocument.vue?vue&type=script&lang=ts"
export * from "./LibraryDocument.vue?vue&type=script&lang=ts"

import "./LibraryDocument.vue?vue&type=style&index=0&id=33149ba8&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33149ba8"]])

export default __exports__